import { $rtkApi } from 'shared/api/rtkApi';
import { validateSetupManagementLink } from '../model/managementLink';

type SetupManagementLink = { telegramBindUrl: string };

const setupManagementApi = $rtkApi.injectEndpoints({
  endpoints: (build) => ({
    createSetupManagementLink: build.mutation<
      SetupManagementLink,
      { token: string }
    >({
      queryFn: async (body, _api, _options, baseQuery) => {
        const result = await baseQuery({
          url: '/api/user/setup-management-link',
          method: 'POST',
          body,
          cache: 'no-store',
        });
        if (result.error) {
          return {
            error:
              typeof result.error.status === 'number'
                ? { status: result.error.status, data: undefined }
                : {
                    status: 'CUSTOM_ERROR',
                    error: 'Setup management link unavailable',
                  },
          };
        }

        const url =
          result.data &&
          typeof result.data === 'object' &&
          'telegramBindUrl' in result.data
            ? validateSetupManagementLink(result.data.telegramBindUrl)
            : undefined;
        return url
          ? { data: { telegramBindUrl: url } }
          : {
              error: {
                status: 'CUSTOM_ERROR',
                error: 'Setup management link unavailable',
              },
            };
      },
    }),
  }),
});

export const useCreateSetupManagementLink =
  setupManagementApi.useCreateSetupManagementLinkMutation;
